import { AbstractControl, ValidatorFn } from "@angular/forms";

export function VerifyRuleName():ValidatorFn {
    
    return (control:AbstractControl): {[key:string]:any} | null => {
        const regex = new RegExp('^[a-zA-Z0-9_-\\s]*$')
        if(control.value){
            const valid = regex.test(control.value[0])
            return valid ? {} : {invalidName:true}
        }
    }
}